import { MenuItem, Select, Typography } from "@mui/material";
import {
  filterFieldOperators,
  isRelativeDateCondition,
  mapDateOperator,
  mapToDateCondition,
} from "../../../segment-operation/operators";

import type { UsableAccountPersonField } from "../../../../server/supabase-segment-field-service";
import type { Condition } from "../../../../types/segment-schema";
import type { DateOperator } from "../../../segment-operation/operators";
import type { SelectChangeEvent } from "@mui/material";
import type { FC } from "react";

export const DateOpSelect: FC<{
  condition: Condition;
  fieldType: Extract<UsableAccountPersonField["field_type"], "DATE" | "MONTH_DAY">;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
}> = ({ condition, fieldType, handleFieldChange, disabled }) => {
  const operator = mapDateOperator(condition);
  const showBlankValuesHelperText = operator === "NOT AFTER" || operator === "NOT BEFORE";

  return (
    <>
      <Select
        variant="outlined"
        size="small"
        label="Operator"
        onChange={(event: SelectChangeEvent) => {
          handleFieldChange({
            ...condition,
            // oxlint-disable-next-line typescript/no-unsafe-type-assertion
            ...mapToDateCondition(event.target.value as DateOperator, condition, fieldType),
          });
        }}
        labelId="operator-label"
        value={operator}
        disabled={disabled}
      >
        {filterFieldOperators[fieldType].operators.map((operatorInfo) => (
          <MenuItem key={operatorInfo.operator} value={operatorInfo.operator}>
            {operatorInfo.label()}
          </MenuItem>
        ))}
      </Select>
      {showBlankValuesHelperText ? (
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: 10 }}>
          *includes blank values
        </Typography>
      ) : null}
      {isRelativeDateCondition(condition) ? (
        <Typography variant="caption" color="textSecondary" sx={{ fontSize: 10 }}>
          * relative to send date
        </Typography>
      ) : null}
    </>
  );
};
